import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterSelfServeBackClick } from "@faire/web-api/events/helpCenter/click/selfServeBack";
import { Button } from "@faire/web/slate/Button";
import { Chevron } from "@faire/web/slate/icons/foundation/Chevron";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useIssueType } from "../hooks/useIssueType";
import { useNavigation } from "../hooks/useNavigation";
export var BackButton = function BackButton() {
  var _getRetailerToken, _getBrandToken;
  var _useNavigation = useNavigation(),
    goToPreviousStep = _useNavigation.goToPreviousStep;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var history = useHistory();
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var handleBackButtonClick = function handleBackButtonClick() {
    trackHelpCenterSelfServeBackClick(retailerToken, brandToken, history.location.pathname, issueType);
    goToPreviousStep();
  };
  if (isMobile) {
    return null;
  }
  return /*#__PURE__*/React.createElement(GoBackCTA, {
    variant: "tertiary",
    onClick: handleBackButtonClick
  }, /*#__PURE__*/React.createElement(LeftChevron, {
    fontSize: "10",
    direction: "left"
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SQqy04",
    defaultMessage: "Back"
  })));
};
var GoBackCTA = styled(Button).withConfig({
  displayName: "BackButton__GoBackCTA"
})([""]);
var LeftChevron = styled(Chevron).withConfig({
  displayName: "BackButton__LeftChevron"
})(["color:", ";"], Core.icon["default"]);